<template>
  <section
    class="swiper band"
    style="background-color: transparent"
    :key="`${title}__common_band_catalog`"
    v-if="catalogInfo && isVisible"
  >
    <div
      :id="`multi_section_index_${multisectionIndex}`"
    >
      <CatalogBandTitle :section-info="sectionInfo" />
      <LoadingBand
        :cell-type="cellType"
        :is-loading="loading"
        :container-class-name="getCellListContainerClassName"
      />
      <CellList
        v-if="hasCellList"
        :cell-list="cellList"
        :thumbnail-info="thumbnailInfo"
        :container-class-name="containerClassName"
        @cell-click-log="sendCellClickLog"
      />
      <ViewMore
        v-if="hasViewMoreCatalog"
        :route-to-list-fn="routeToViewMore"
        :view-more-title="title"
      />
    </div>
  </section>
</template>
<script setup>
import { ref, defineProps, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router/composables'
import { hasViewMore, routeToList } from '@/common/util/common'
import { convertBand } from '@/common/converter/convert-band'
import { getBandTypeInfoByCellType, getCellListContainerClassName } from '@/common/image.util'
import { getCellType } from '@/common/converter/utils/get-cell-type'
import { sendEventLogSearchCell } from '@/common/util/log.v2.send'
import CellList from '@/components/section/template/cell/CellList'
import ViewMore from '@/components/section/template/viewmore/ViewMore'
import CatalogBandTitle from '@/components/catalog/CatalogBandTitle.vue'
import LoadingBand from '@/components/section/template/LoadingBand.vue'

// todo: vue 2 문법 적용 -> v-on-display / v-band-title 디렉티브 사용

const props = defineProps({
  catalogInfo: {
    type: Object,
    default: () => {}
  },
  sectionInfo: {
    type: Object,
    default: null
  },
  multisectionIndex: {
    type: Number,
    default: 0
  }
})

const route = useRoute()

const loading = ref(true)
const cellList = ref([])
const isVisible = ref(true)
const band = ref({})
const isLoaded = ref(false)
const title = computed(() => props.sectionInfo?.title ?? '')
const cellType = computed(() => getCellType(props.catalogInfo?.elementList))
const thumbnailInfo = computed(() => getBandTypeInfoByCellType(cellType.value))
const containerClassName = computed(() => getCellListContainerClassName(cellType.value))
const hasViewMoreCatalog = computed(() => hasViewMore(props.sectionInfo))
const hasCellList = computed(() => cellList.value.length > 0)

const routeToViewMore = () => {
  routeToList(props.sectionInfo, route)
}

const sendCellClickLog = ({ cellInfo = {}, index = -1, routeName = '' }) => {
  sendEventLogSearchCell({ cellInfo: cellInfo, index: index, routeName: routeName })
}

const getVisibleState = () => {
  isVisible.value = cellList.value.length !== 0
}

const setData = async () => {
  isVisible.value = false
  try {
    band.value = await convertBand(props.catalogInfo)
    cellList.value = band.value?.band?.celllist ?? []

    getVisibleState()
    isLoaded.value = true
    loading.value = false
  } catch (e) {
    isVisible.value = false
  }
}

onMounted(async () => {
  await setData()
})

</script>
